import Page from './Page';
import Overlay from "./Overlay";
import Menu from "./Menu";


let imgSizeOrder = {
	'mobile': [
		['wide', 'small', 'portrait', 'portrait', 'small', 'wide'],
		['wide', 'portrait', 'small', 'portrait', 'small', 'wide'],
	],
	'desktop': [
		['portrait', 'wide', 'small', 'portrait', 'wide', 'small'],
		['portrait', 'small', 'wide', 'portrait', 'wide', 'small'],
		['wide', 'portrait', 'small', 'portrait', 'wide', 'small']
	]
};

export default class Gallery extends Page
{
	constructor () {

		super();

		window.gallery = this;

		let videoGallery = document.querySelector('.episode.gallery');

		if ( videoGallery )
		{

			// init the video extra stuff
			new Overlay(videoGallery.querySelector('.list'));
		}
		else
		{

			// init the masonry stuff
			this.init();
		}


	}

	clear ()
	{
		if ( this.msnry )
		{
			this.gridItems.forEach(item =>
			{
				this.msnry.remove( item);
			})

		}
	}


	addNew ()
	{
		if ( this.msnry )
		{
			this.msnry.addItems(this.gridItems);


		}
	}

	init ()
	{

		if ( this.msnry )
		{
			this.msnry.destroy();
			this.msnry = undefined;
		}

		this.screenSize = 'mobile';

		this.grid = document.getElementById('gallery_masonry');
		this.gridItems = document.querySelectorAll(".grid_item");


		let mql = window.matchMedia( '( min-width: 768px )' );
		mql.addEventListener('change', this.setScreenSize.bind(this) );
		this.setScreenSize(mql);

		this.setImgSizes();

		new Overlay(this.grid);
		new Menu('submenu');
	}

	setScreenSize ( mql ) {

		if ( mql.matches )
		{
			this.screenSize = 'desktop';
			this.groupCount = 3;
		}
		else
		{
			this.screenSize = 'mobile';
			this.groupCount = 2;
		}

		this.setImgSizes();

	}


	setImgSizes () {

		let group = 0;
		let id = 0;

		this.gridItems.forEach(item => {


			if ( Page.hasClass(item, 'group_br'))
			{
				return;
			}

			Page.removeClass(item, 'small');
			Page.removeClass(item, 'wide');
			Page.removeClass(item, 'portrait');

			let newSize = imgSizeOrder[this.screenSize][group][id];
			Page.addClass(item, newSize);
			let img = item.querySelector('img');
			img.src = img.getAttribute('data-' + newSize);


			id++;
			if ( id > 5 )
			{
				group++;
				id = 0;
			}
			if ( group >= this.groupCount )
			{
				group = 0;
			}

		});

		if ( this.msnry )
		{
			this.msnry.layout();
		}
		else
		{
			this.msnry = new Masonry( this.grid, {
				itemSelector: '.grid_item',
				columnWidth: '.grid_size',
				gutter: '.grid_gutter'
			});
		}

	}

}